import { render, staticRenderFns } from "./CenterViewBehalfCreateComplate_Ap.vue?vue&type=template&id=ebedc244&scoped=true"
import script from "./CenterViewBehalfCreateComplate_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewBehalfCreateComplate_Ap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebedc244",
  null
  
)

export default component.exports